import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const WORKFLOW_COUNT_FOR_LIMIT_FIELDNAME = 'workflowCountForLimit';
export const GET_WORKFLOW_COUNT_FOR_LIMIT = registerQuery({
  fieldName: WORKFLOW_COUNT_FOR_LIMIT_FIELDNAME,
  fetcher: () => {
    const data = {
      objectTypeId: '0-44',
      count: 0,
      filterGroups: [{
        filters: [{
          operator: 'EQ',
          value: 'true',
          property: 'hs_is_counted_towards_hub_limits_usage'
        }, {
          operator: 'EQ',
          value: 'false',
          property: 'hs_is_deleted'
        }, {
          operator: 'IN',
          values: ['WORKFLOWS_APP', 'WORKFLOWS_CLASSIC', 'DIRECT_API'],
          property: 'hs_source_app'
        }]
      }]
    };
    return http.post(`crm-search/search`, {
      data
    }).then(response => response.total || 0);
  }
});
export const useWorkflowsCount = () => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_WORKFLOW_COUNT_FOR_LIMIT);
  const totalWorkflowCount = data && data[WORKFLOW_COUNT_FOR_LIMIT_FIELDNAME] || 0;
  return {
    totalWorkflowCount,
    totalWorkflowCountIsLoading: loading,
    totalWorkflowCountError: error
  };
};